import styled from 'styled-components';
import {ToggleSwitch} from '@/components/ToggleSwitch';
import {Typography} from '@/components/Typography';
import {FranchiseItem} from '@/map/@types';
import {Flexbox, FlexFullGrow, PaddingBox} from '@/styled-components';
import {Logo} from './Logo';

interface IProps {
  item: FranchiseItem;
  active?: boolean;
  onToggle(id: string, active: boolean): void;
}

export const Item = ({item, active, onToggle}: IProps) => {
  const handleToggle = () => onToggle(item.id, !active);

  return (
    <Root>
      <Flexbox>
        <Flexbox>
          <Logo item={item} />
          <PaddingBox left={4}>
            <Typography variant="medium14" fontWeight="700">
              {item.overriden?.name ?? item.name}
              {!item.franchiseeCount && <span>&nbsp;(가맹점 정보 없음)</span>}
            </Typography>
          </PaddingBox>
        </Flexbox>
        <FlexFullGrow />
        <ToggleSwitch
          checked={active}
          variant="small"
          onChange={handleToggle}
        />
      </Flexbox>
    </Root>
  );
};

const Root = styled.div`
  padding: 13px 16px;
`;
